import { Component, OnInit } from '@angular/core';
import { ProjectServicesService } from '../shared/services/project-services.service';
import { SharedService } from '../shared/services/shared.service';
import { Config } from '../config';
import { AppService } from '../shared/services/app.service';
// import * as $ from 'jquery';
declare var $: any;
// import diff from 'fast-diff';
// import diff = require('fast-diff');

import diff from 'fast-diff';
import QuillType from 'quill';
declare module 'quill';
import Delta from 'quill';

import {
  faInfo,
  faFileExport,
  faChevronLeft,
  faChevronRight,
  faPlus,
  faPenNib,
  faSearch,
  faBoxOpen,
  faCircle,
  faSitemap,
  faInfoCircle,
  faPlusSquare,
  faEdit,
  faLightbulb,
  faTrash,
  faDotCircle,
  faCircleNotch,
  faTimesCircle,
  faCheckCircle,
  faRedo,
  faSave
  // faBug,
} from '@fortawesome/free-solid-svg-icons';
import quill, { Quill } from 'quill';
import { EditorChangeContent, EditorChangeSelection, Focus } from 'ngx-quill';
import { NotificationsComponent } from '../notifications/notifications.component';
import { Subscription } from 'rxjs';
import { SocketService } from '../shared/services/socket.service';
import { JiraBugsListComponent } from '../jira-bugs-list/jira-bugs-list.component';
import { faJira } from '@fortawesome/free-brands-svg-icons';
import { ReloadToolService } from '../shared/services/reload-tool.service';
import { MainComponent } from '../main/main.component';
declare module 'quill';

@Component({
  selector: 'app-test-designer',
  templateUrl: './test-designer.component.html',
  styleUrls: ['./test-designer.component.scss'],
})
export class TestDesignerComponent implements OnInit {
  faCircle = faCircle;
  faPenNib = faPenNib;
  faLightbulb = faLightbulb;
  faSitemap = faSitemap;
  faInfoCircle = faInfoCircle;
  faSearch = faSearch;
  faFileExport = faFileExport;
  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;
  faCheckCircle = faCheckCircle;
  faDotCircle = faDotCircle;
  faCircleNotch = faCircleNotch;
  faTimesCircle = faTimesCircle;
  faPlus = faPlus;
  faBoxOpen = faBoxOpen;
  faJira = faJira;
  faPlusSquare = faPlusSquare;
  faEdit = faEdit;
  faTrash = faTrash;
  faRedo = faRedo;
  faSave = faSave;
  // Quill = Quill;
  clickEventsubscriptionSocket: Subscription;
  smartChecklist: boolean = true;
  scenarioEmpty: any;
  syncModelDataObject: any;


  constructor(
    private ProjectServices: ProjectServicesService,
    private _sharedService: SharedService,
    private reloadToolService: ReloadToolService,
    private socketService: SocketService,
    public mainComponent: MainComponent,
    public Config: Config,
    private AppService: AppService,
    public notificationsComponent: NotificationsComponent, // public quill: Quill
    public jiraBugsListComponent: JiraBugsListComponent
  ) {
    this.clickEventsubscriptionSocket = this.socketService
      .getClickEvent()
      .subscribe(() => {
        this.ngOnInit();
      });

    this.clickEventsubscription = this._sharedService
      .getClickEvent()
      .subscribe((eut) => {
        this.activate(eut);
      });
  }

  // taskplanner = taskplanner;
  // scopeMap = scopeMap;
  // listOfEUTs = listOfEUTs;
  // model = model;
  // AppService = AppService;
  // eutDetails = eutDetails;
  listOfAttributes: any;
  toastMsgPopup: any;
  message: any = '';
  index: any = 0;
  // quill = quill;
  eutDetails: any;
  scenarioStatusTestTypes: any = [];
  errorMessage = '';
  duplicateScenario = '';
  editorContent: any = '';
  matchedScenario: any = '';
  selectedChecklistAttr: any;
  editorContentText: any;
  selectedString: any;
  selectedEntityeID: any = '';
  entityScenarioNill: boolean = false;
  entityScenarioOne: boolean = false;
  entityScenarioAll: boolean = false;
  model: any;
  widgetDisabled: any = true;
  selectedDeleteScenEid: any = '';
  eutTypes: any = ['TF', 'UR', 'BF'];
  clickEventsubscription: Subscription;
  // , "TT"
  matchedAttribute: any;
  designTest: any = 'E';
  entityName: any;
  selectedEntity: any = {
    bDescription: '',
    bc: '',
    ac: '',
    outcomes: '',
    pIssues: '',
  };
  selectedEntityNotes: any = {};
  selectedEntityDetails: any = {};
  editScenario: any = '';
  selectedTest: any = '';
  selectedModule: any = {};
  selectedEUT: any = 'TF';
  newscenarioattr: any = 'Feature Behaviour';
  newscenariosymbol: any = 'Fe';
  newscenariocr: any = '+';
  scenarioTypes = ['+', '-'];
  newscenariopriority: any = '+';
  newscenariodesc: any = '';
  editscenariodesc: any = '';
  selectedEditorAttribute = { symbol: 'Mi', name: 'Migration', level: 'L8' };
  selectedEditorAttr: any = {};
  newscenariopersona: any = [];
  entityBC: any;
  entityAC: any;
  entityOC: any;
  entityPI: any;
  testTypes: any = [
    {
      name: 'Feature Behaviour',
      symbol: 'Fe',
      eType: 'TF',
      level: 'L4',
    },
    {
      name: 'Requirement Behaviour',
      symbol: 'Rb',
      eType: 'UR',
      level: 'L5',
    },
    {
      name: 'Flow Behaviour',
      symbol: 'Fb',
      eType: 'BF',
      level: 'L5',
    },
  ];
  range: any = new Array(3);
  selectedTestName: any = '';
  modelData: any;
  config: any;
  quillEditorContent: any = '';
  // quill: any = '';
  filterTypeCount: any = { type: 'count' };
  filterTypeList: any = { type: 'list' };
  // priority = ["***", "**", "*"];
  priority = ['+P1', '+P2', '+P3', '-P1', '-P2', '-P3'];
  // appService = angular
  //   .element(document.body)
  //   .injector()
  //   .get("AppService");
  bcList: any = [];

  options: any = {
    space: '',
    openSquareBracket: '[',
    closeSquareBracket: ']',
    openRoundBracket: '(',
    closeRoundBracket: ')',
    comma: ',',
  };
  // modules: any = {
  //   toolbar: [
  //     ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
  //     ['blockquote', 'code-block'],

  //     [{ 'header': 1 }, { 'header': 2 }],               // custom button values
  //     [{ 'list': 'ordered'}, { 'list': 'bullet' }],
  //     [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
  //     [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
  //     [{ 'direction': 'rtl' }],                         // text direction

  //     [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
  //     [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

  //     [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
  //     [{ 'font': [] }],
  //     [{ 'align': [] }],

  //     ['clean'],                                         // remove formatting button

  //     ['link', 'image', 'video']                         // link and image, video
  //   ]
  // };
  searchText: any = '';
  showText: any = false;
  new: any = true;
  checklistName: any = '';
  attrDisabled: any = false;
  actionBtnsEnabled: any = false;
  plusBtnEnabled: any = true;
  editCheckList: any = false;
  toastMsg: any;
  fieldsDisabled: any;
  oldCheckListName: any = '';
  attributeSelected: any = [];
  levelSelected: any = [];
  currentTab: any = 'specs';
  personaSelected: any = [];
  newscenariolevel: any = '';
  selectedEditorLevel: any = 'L8';
  crSelected: any = [];
  jiraProjectData: any;
  jiraInterfaceDisabled: boolean = false;
  proDataSubscription: Subscription = new Subscription();

  ngOnInit(): void {
    $(() => {
      $('[data-toggle="popover"]').popover();
      $('[data-toggle="tooltip"]').tooltip();
    });

    this.changeTab('scenario');
    setTimeout(() => {
      this.getVideoURL('Td');
      this.jiraProjectData = this._sharedService.jiraProjectData;
      // console.log('this.jiraProjectData', this.jiraProjectData);
      if (this.jiraProjectData.length === 0) {
        this.jiraInterfaceDisabled = true;
      }
    }, 2000);
    this.config = this.Config;
    this.proDataSubscription = this._sharedService.projectJsonSubject.subscribe(data => {
      this.modelData = data.model;
    });
    this.selectedModule = this.modelData.modules[0];
    // this.modelData = this._sharedService.loadedProjectData.model;
    this.jiraProjectData = this._sharedService.jiraProjectData;
    this.quillNoteReload();
    this.selectedEditorAttr = this.config.listOfAttributesUpdated.find(
      (att: any) => att.symbol == this.selectedEditorAttribute.symbol
    );
    setInterval(() => {
      this.updateProjectData();
    }, 2000);
    this.selectTest(this.testTypes[0]);
    this.reloadToolService.triggerSmartChecklist('');
    window.localStorage.removeItem("entityTestName");
  }

  updateProjectData() {
    this._sharedService.projectContent(this.modelData);
  }
  openChatGPTassist() {
    this.mainComponent.openChatGPT();
    window.localStorage.setItem("assistantTool", "ET-DE");
    if (this.selectedEntity.eName) {
      window.localStorage.setItem("entityTestName", this.selectedEntity.eName);
    }
    // setTimeout(() => {
    //   if (this.choosenEUT) {
    //     this.loadEntityDetails(this.choosenEUT);
    //   }
    // }, 500);
  }
  updateTestTypeStatus() {
    if (this.selectedEntity) {
      var foundEntityDetails = this.modelData.EUTdetails.find((entity: any) => entity.eID == this.selectedEntity.eID)

      this.scenarioStatusTestTypes = [];
      this.scenarioStatusTestTypes = this.testTypes.concat(this.config.listOfAttributesUpdated);

      for (var i = 0; i < this.scenarioStatusTestTypes.length; i++) {


        if (foundEntityDetails.testTypes) {

          var fountTestType = foundEntityDetails.testTypes.find((test: any) => this.scenarioStatusTestTypes[i].symbol == test.symbol)
          if (fountTestType) {
            this.scenarioStatusTestTypes[i]['satisfy'] = true;
          } else {
            this.scenarioStatusTestTypes[i]['satisfy'] = false;
          }
        } else {
          this.scenarioStatusTestTypes[i]['satisfy'] = false;
        }

        if (this.scenarioStatusTestTypes[i].symbol == "Fe" || this.scenarioStatusTestTypes[i].symbol == "Rb" || this.scenarioStatusTestTypes[i].symbol == "Fb") {
          this.scenarioStatusTestTypes[i]['satisfy'] = true;
        }
        var foundScenario = this.modelData.scenarios.find((scenario: any) => scenario.attribute.symbol == this.scenarioStatusTestTypes[i].symbol && scenario.eID == this.selectedEntity.eID)
        if (foundScenario) {
          this.scenarioStatusTestTypes[i]['stated'] = true;
        } else {
          this.scenarioStatusTestTypes[i]['stated'] = false;
        }
      }
    }
  }
  scenariosStatus() {
    if (this.selectedEntity) {
      this.entityScenarioNill = true;
      this.entityScenarioOne = false;
      this.entityScenarioAll = false;
      var foundEntityDetails = this.modelData.EUTdetails.find((entity: any) => entity.eID == this.selectedEntity.eID)
      if (foundEntityDetails) {
        if (foundEntityDetails.testTypes) {
          var entityTestTypes = foundEntityDetails.testTypes;
          var scenarioCount = 0
          var scenariosFound = true;
          for (var i = 0; i < entityTestTypes.length; i++) {
            for (var j = 0; j < this.modelData.scenarios.length; j++) {
              if (entityTestTypes[i].symbol == this.modelData.scenarios[j].attribute.symbol) {
                scenarioCount++;
              }
            }
            var scenarioFound = this.modelData.scenarios.find((scenario: any) => scenario.attribute.symbol == entityTestTypes[i].symbol)
            if (!scenarioFound) {
              scenariosFound = false;
            }
          }
          if (scenariosFound == true) {
            if (scenarioCount > 0) {
              this.entityScenarioNill = false;
              this.entityScenarioOne = true;
              this.entityScenarioAll = false;
            } else {
              this.entityScenarioNill = true;
              this.entityScenarioOne = false;
              this.entityScenarioAll = false;
            }
          } else {
            this.entityScenarioNill = false;
            this.entityScenarioOne = false;
            this.entityScenarioAll = true;
          }

        }
      }
    }
  }
  openSmartChecklist() {
    this.reloadToolService.triggerSmartChecklist('la');
    if (this.smartChecklist == false) {
      $(".autoCursor").addClass('checklistIcon');
      this.smartChecklist = true;
    } else {
      $(".autoCursor").removeClass('checklistIcon');
      this.smartChecklist = false;
    }
  }
  loadBugList() {
    // this.jiraBugsListComponent.loadData();
    window.open('/jirabugslist', '_blank');
  }

  // this.quill = {"new"}
  // onReloadInit(eutDetails,  scopeMap, listOfEUTs) {
  //   console.log('reload init for designer', this.selectedEntity);
  //   this.scopeMap = scopeMap;
  //   this.eutDetails = eutDetails;
  //   this.listOfEUTs = listOfEUTs;
  //   if (this.selectedEntity) {
  //     this.selectedEntityfound = this.listOfEUTs.find(eut => eut.eID == this.selectedEntity.eID);
  //     console.log('selectedEntityfound', this.selectedEntityfound);
  //     if (this.selectedEntityfound) {
  //       this.loadEntityDetails(this.selectedEntityfound);
  //     } else {
  //       this.selectedEntity = {};
  //       this.selectedEntityDetails = {};
  //       this.entityName = "";
  //       this.selectedTest = "";
  //       this.selectedTestName = "";
  //     }
  //   }
  // }

  // quillNoteReload() {
  //   // console.log('quillNote called');
  //   // console.log('project id', window.localStorage.getItem("projectID"));
  //   var iframe = document.getElementById('designerNotepad');
  //   iframe.src = iframe.src;
  // }

  createActivity(appname: any) {
    // console.log('appname', appname);
    if (
      appname != 'Db' &&
      appname != 'Lo' &&
      appname != 'Nt' &&
      appname != 'Snt' &&
      appname != 'No' &&
      appname != 'XX' &&
      appname != 'Tdsp' &&
      appname != 'Tdsc' &&
      appname != 'Tdde' &&
      appname != 'Exsc' &&
      appname != 'Exde' &&
      appname != 'Exsp'
    ) {
      this.getVideoURL(appname);
    }
    var sessionID = localStorage.getItem('sessionID');
    var projectID = localStorage.getItem('projectID');
    var userID = localStorage.getItem('userID');
    if (sessionID == null) {
      sessionID = '';
    }
    let activityData = {
      appname: appname,
      sessionid: sessionID,
      projectid: projectID,
      userid: userID,
    };

    this.AppService.updateActivity(activityData).subscribe((response: any) => {
      // console.log('updateActivity response', response);
      if (response.statusCode === 200) {
        if (response.sessionid != undefined) {
          localStorage.setItem('sessionID', response.sessionid);
          this.notificationsComponent.getNotifications();
        }
        if (localStorage.getItem('sessionID') != undefined && appname == 'No') {
          this.notificationsComponent.getNotifications();
        }
      }
    });
  }

  getVideoURL(urlName: any) {
    var videoURL = this.AppService.getVideoURL(urlName);
    var element: any = document.getElementById(urlName + 'VideoLink') || {};
    element.src = videoURL;
  }
  changeTab(tabName: any) {
    this.currentTab = tabName;
    // console.log(this.currentTab);
  }
  // var quill = new Quill('#editor', {
  //   modules: {
  //     toolbar: toolbaroptions
  //   },
  //   theme: 'snow',
  //   strict: false
  // });
  // onfocusData($event: any){
  //   console.log("Focus", $event);
  // }
  // quill.on('selection-change', function(range: { length: number; index: any; }, oldRange: any, source: any) {
  //   if (range) {
  //     if (range.length == 0) {
  //       console.log('User cursor is on', range.index);
  //     } else {
  //       // var text = quill.getText(range.index, range.length);
  //       // console.log('User has highlighted', text);
  //     }
  //   } else {
  //     console.log('Cursor not in the editor');
  //   }
  // });
  editorChanged(event: EditorChangeContent | EditorChangeSelection) {
    this.editorContent = event['editor']['root']['innerHTML'];
    this.editorContentText = event['editor']['root']['innerText'];
    // console.log('Changed', event);
    if (event['event'] == 'selection-change') {
      var range: any = event['range'];
      this.selectedString = '';
      var text = event.editor.getText(range['index'], range['length']);
      // console.log("text",text);
      // console.log('text1', this.editorContentText);
      // console.log('index', this.editorContentText.replace(/\r?\n|\r/, ''));
      // var newText = this.editorContentText.replace(/\s+/g, '');
      // console.log('tt', newText.substr(range['index'], range['length']));
      this.selectedString = text.split('\n');
      // this.selectedString = cleanArray.filter(function (el: any) {
      //   return el != null;
      // });
      this.selectedString = this.selectedString.filter((item: any) => item);
      // console.log('text', this.selectedString);
    } else {
      let project = {
        projectID: window.localStorage.getItem('projectID'),
        userID: window.localStorage.getItem('userID'),
        content: this.editorContent,
      };
      // console.log('text', this.editorContent);
      // this.ProjectServices.addDesignerContent(project).subscribe(
      //   (response: any) => {
      //     // console.log('res', response);
      //     if (response.statusCode == 200) {
      //       // this.quillEditorContent = response.record.content;
      //     } else {
      //     }
      //   }
      // );
    }
  }
  // focus(event: Focus) {
  //   // tslint:disable-next-line:no-console
  //   console.log('focus', event)
  //   // this.focused = true
  //   // this.blurred = false
  // }

  blur(event: Focus) {
    var foundNotes = false;
    let notesObject;
    if (this.selectedEntity.eID) {
      if (this.modelData.myNotes.length > 0) {
        for (var i = 0; i < this.modelData.myNotes.length; i++) {
          if (this.modelData.myNotes[i].eID == this.selectedEntity.eID) {
            this.modelData.myNotes[i]['notes'] = this.editorContent;
            foundNotes = true;
            this.syncModelDataObject = {
              "type": "NOTES",
              "operation": "UPDATE",
              "data": this.selectedEntity,
              "notes": this.editorContent
            }
            this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
          }
        }
        if (foundNotes == false) {
          notesObject = {
            "eID": this.selectedEntity.eID,
            "notes": this.editorContent
          }
        }
      } else {
        notesObject = {
          "eID": this.selectedEntity.eID,
          "notes": this.editorContent
        }
      }
      if (notesObject != null) {
        this.modelData.myNotes.push(notesObject);
        this.syncModelDataObject = {
          "type": "NOTES",
          "operation": "CREATE",
          "data": notesObject
        }
        this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
      }
      // console.log(this.modelData.myNotes);
    }
  }

  // selectedAttribute(attr: any) {
  //   this.selectedEditorAttribute = attr;
  // }
  // onFocus(event){
  //   console.log("Changed", event);
  // }

  quillNoteReload() {
    let project = { projectId: window.localStorage.getItem('projectID') };
    this.ProjectServices.getDesignerContent(project).subscribe(
      (response: any) => {
        // console.log('res', response);
        if (response.statusCode == 200) {
          if (response.record) {
            // this.quillEditorContent = response.record.content;
            // this.quill.root.innerHTML = response.record.content;
            // getEditorContentData = response.record.content;
          }
        } else {
        }
      }
    );
  }
  checkQuillSelection() {
    // console.log('Attr', this.selectedEditorAttribute.symbol);
    // console.log("level", this.newscenariolevel);
    // console.log('List', this.selectedString);
    // console.log('EUT', this.selectedEntity);
    if (this.selectedEntity.eID) {
      for (var i = 0; i < this.selectedString.length; i++) {
        this.matchedScenario = this.modelData.scenarios.find(
          (scen: any) =>
            scen.tID == this.selectedTest.symbol &&
            scen.description.toLowerCase() == this.selectedString[i].toLowerCase() &&
            scen.eID == this.selectedEntity.eID
        );
        if (!this.matchedScenario) {
          // if (this.selectedString[i]) {
          this.addScenario(
            '',
            this.selectedString[i],
            this.selectedEntity.eID,
            this.selectedTest,
            '-1',
            'E',
            '+',
            '1'
          );
          // }
        } else {
          // this.errorMessage = this.AppService.getResourceText("V033");
          this.errorMessage = "Scenario already exists";
          this.duplicateScenario = "'" + this.matchedScenario.description + "'";
          $("#duplicateScenarioErrorPopupModelDesigner").modal("show");
        }
      }
    } else {
    }
  }
  // quill.on('selection-change', function (range) {
  //   if (range) {
  //     if (range.start == range.end) {
  //       // console.log('User cursor is on', range.start);
  //       $("#entitySelect").hide();
  //       // $("#attributeSelect").hide();
  //       document.getElementById("attributeSelect").selectedIndex = 0;
  //     } else {
  //       var text = editor.getText(range.start, range.end);
  //       // console.log('User has highlighted', text);
  //     }
  //   } else {
  //     $("#entitySelect").hide();
  //     // $("#attributeSelect").hide();
  //     document.getElementById("attributeSelect").selectedIndex = 0;
  //     // console.log('User cursor is not in editor');
  //   }
  // });
  // quill.on('text-change') function () {
  //   // var delta = quill.getContents();
  //   var text = this.quill.getText();
  // var justHtml = this.quill.root.innerHTML;
  // changeEditorContentData = this.quill.root.innerHTML;
  // preciousContent.innerHTML = JSON.stringify(delta);
  // justTextContent.innerHTML = text;
  // justHtmlContent.innerHTML = justHtml;
  // console.log("HTML", justHtml);

  // if (getEditorContentData != changeEditorContentData) {
  //   var token = window.localStorage.getItem("publicToken");
  //   var projectID = window.localStorage.getItem("projectID");
  //   var userID = window.localStorage.getItem("userID");
  //   var jsonObjects = { projectID: projectID, userID: userID, content: justHtml };
  //   jQuery.ajax({
  //     url: serverUrl + "/addDesignerContent",
  //     type: "POST",
  //     async: true,
  //     processData: false,
  //     data: JSON.stringify(jsonObjects),
  //     dataType: "json",
  //     cache: false,
  //     contentType: "application/json",
  //     headers: {
  //       "Authorization": token,
  //     },
  //     success: function (result) {
  //       // console.log('result', result);
  //     }
  //   });
  // }
  // });
  entitiesExists(eType: any) {
    var entities = [];
    entities = this.modelData.listOfEUTs.filter(
      (entity: any) => entity.mID == this.selectedModule.mID
    );
    if (entities.length > 0) {
      return true;
    } else {
      return false;
    }
  }
  getEntityTypeName() {
    if (this.selectedEUT == 'TF') {
      return 'features';
    } else if (this.selectedEUT == 'UR') {
      return 'requirements';
    } else if (this.selectedEUT == 'BF') {
      return 'flows';
    } else {
      return 'entities';
    }
  }
  resetDesignerRowColorOnFilter() { }
  // new code open
  selectedCheckList(newButton: any, textBox: any, checkname: any) {
    this.checklistName = checkname;
    this.new = newButton;
    this.showText = textBox;
    this.attrDisabled = true;
    this.selectedTestName = '';
    this.actionBtnsEnabled = false;
    this.plusBtnEnabled = true;
  }
  checklistNameChanged(checkname: any, edit: any) {
    if (checkname != '') {
      var existCheckListName = '';
      // this.modelData.scenarios.filter(
      //   scenario =>
      //     scenario.checklist == checkname
      // );
      if (existCheckListName.length == 0 && edit == false) {
        this.fieldsDisabled = false;
        this.showText = false;
        this.new = false;
        this.checklistName = checkname;
        this.attrDisabled = false;
        this.editCheckList = false;
        this.actionBtnsEnabled = true;
        this.plusBtnEnabled = true;
      } else if (existCheckListName.length == 0 && edit == true) {
        // for (let s = this.model.scenarios.length - 1; s >= 0; s--) {
        //   if (this.model.scenarios[s].checklist == this.oldCheckListName) {
        //     this.model.scenarios[s].checklist = checkname;
        //   }
        // }
        // for (let t = this.model.tasks.length - 1; t >= 0; t--) {
        //   if (this.model.tasks[t].entity_desc == this.oldCheckListName) {
        //     this.model.tasks[t].entity_desc = checkname;
        //   }
        // }
        this.actionBtnsEnabled = true;
        this.plusBtnEnabled = true;
        this.fieldsDisabled = false;
        this.showText = false;
        this.new = false;
        this.checklistName = checkname;
        this.attrDisabled = true;
        this.editCheckList = false;
        this.oldCheckListName = '';
      } else {
        // this.triggerToastPopup(this.AppService.getResourceText("V022"));
      }
    }
  }

  triggerToast(message: any) {
    this.toastMsg = message;
    $('#snackbar').html(message);
    var x = document.getElementById('snackbar');
    // x.className = "show";
    // setTimeout(function () {
    //   x.className = x.className.replace("show", "");
    // }, 3000);
  }
  selectTest(test: any) {
    // console.log("testtest",test);
    this.newscenariosymbol = test.symbol;
    this.selectedTest = test;
    this.selectedTestName = test.name;
    var symbol = test.symbol;
    this.newscenariolevel = test.level;
    // if (symbol == 'Mi' || symbol == 'In' || symbol == 'Co' || symbol == 'Si') {
    //   this.newscenariolevel = 'L8';
    // } else if (symbol == 'Pf' || symbol == 'Lo' || symbol == 'Re' || symbol == 'Se' || symbol == 'Us') {
    //   this.newscenariolevel = 'L7';
    // } else if (symbol == 'Bc' || symbol == 'Ec') {
    //   this.newscenariolevel = 'L6';
    // } else if (symbol == 'Rb' || symbol == 'Fb') {
    //   this.newscenariolevel = 'L5';
    // } else if (symbol == 'Ac' || symbol == 'Fe') {
    //   this.newscenariolevel = 'L4';
    // } else if (symbol == 'Ui' || symbol == 'St' || symbol == 'Dt') {
    //   this.newscenariolevel = 'L123';
    // } else {
    //   this.newscenariolevel = '';
    // }
  }

  selectLevel(level: any) {
    this.newscenariolevel = level;
    if (level != 'L4' && level != 'L5') {
      this.selectedTest = this.config.listOfAttributesUpdated.find(
        (attr: any) => attr.level == level
      );
    } else {
      this.selectedTest = this.config.listofFunctionalityTestTypes.find(
        (attr: any) => attr.level == level
      );
    }
  }

  selectType(type: any) {
    this.newscenariocr = type;
  }
  clear() {
    this.showText = false;
    this.checklistName = '';
    this.attrDisabled = false;
    this.selectedTestName = '';
    this.actionBtnsEnabled = false;
    this.plusBtnEnabled = true;
    this.selectedEntity = {
      bDescription: '',
      bc: '',
      ac: '',
      outcomes: '',
      pIssues: '',
    };
    this.selectedEntityDetails = {};
  }
  deleteCheckList(checklist: any) {
    // for (let s = this.model.scenarios.length - 1; s >= 0; s--) {
    //   if (this.model.scenarios[s].checklist == checklist) {
    //     this.model.scenarios.splice(s, 1);
    //   }
    // }
    // for (let t = this.model.tasks.length - 1; t >= 0; t--) {
    //   if (this.model.tasks[t].entity_desc == checklist) {
    //     this.model.tasks.splice(t, 1);
    //   }
    // }
    this.checklistName = '';
    this.attrDisabled = false;
    this.actionBtnsEnabled = false;
    this.plusBtnEnabled = true;
    this.selectedTestName = '';
    // this.taskplanner.controller.tableCollapseExpand();
  }
  editCheckListName(checklist: any) {
    this.showText = true;
    this.editCheckList = true;
    this.plusBtnEnabled = false;
    this.checklistName = checklist;
    this.oldCheckListName = checklist;
  }
  // new code close

  activate(entity: any) {
    console.log('entity', entity);
    if (entity.toolType == 'de') {

      if (this.modelData.EUTdetails) {
        this.loadEntityDetails(entity);
        this.selectTest(entity.testType);
        this.selectedModule = this.modelData.modules.find(
          (mod: any) => mod.mID == entity.mID
        );
        this.attributeSelected = [];
        // this.addToAttributeFilter(entity.testType.symbol, true);
      } else {
        setTimeout(() => {
          this.loadEntityDetails(entity);
          this.selectTest(entity.testType);
          this.selectedModule = this.modelData.modules.find(
            (mod: any) => mod.mID == entity.mID
          );
        }, 5000);
      }
      this.index = this.eutTypes.findIndex((type: any) => type == entity.eType);
    }
  }
  //Setting the priority and type of the scenario based on what it starts and ends with.
  setPriority(priority: any) {
    this.newscenariocr = priority.charAt(0);
    this.newscenariopriority = priority.substr(priority.length - 1);
  }

  //function to select the design type for scenarios
  //if T is chosen ->its only for a test, therefore entitydropdown will be disabled
  //if E is chosen-> its for an entity with a test type
  selectDesignType(type: any) {
    this.designTest = type;
    this.selectedEntity = {
      bDescription: '',
      bc: '',
      ac: '',
      outcomes: '',
      pIssues: '',
    };
    this.selectedEntityDetails = {};
    this.entityName = '';
    this.selectedTest = '';
    this.selectedTestName = '';
  }

  //changing the entity type by toggling the span button
  //reset the entity name and details populated in the form
  changeEntity() {
    this.index = (this.index + 1) % this.eutTypes.length;
    this.selectedEntity = {
      bDescription: '',
      bc: '',
      ac: '',
      outcomes: '',
      pIssues: '',
    };
    this.selectedEntityDetails = {};
    this.entityName = '';
    this.selectedTest = '';
    this.selectedTestName = '';
    this.attrDisabled = false;
  }

  //handler to get the required details based on the selected entity
  loadEntityDetails(eutChosen: any) {
    // console.log('eutChosen TD', eutChosen);
    // this.selectedEUT = eutChosen;
    // this.selectedModule = eutChosen;
    this.entityName = eutChosen.eName;
    this.selectedEUT = eutChosen.eType;
    this.widgetDisabled = false;
    window.localStorage.setItem('designerSelected', JSON.stringify(eutChosen));
    this.selectedEntity = eutChosen;
    this.selectedEntityeID = eutChosen.eID;
    window.localStorage.setItem('entityTestID', eutChosen.eID);
    if (this.selectedEntity) {
      // console.log(this.modelData);
      if (this.modelData.EUTdetails) {
        this.selectedEntityDetails = this.modelData.EUTdetails.find(
          (eut: any) => eut.eID == eutChosen.eID
        );
      } else {
        setTimeout(() => {
          this.selectedEntityDetails = this.modelData.EUTdetails.find(
            (eut: any) => eut.eID == eutChosen.eID
          );
        }, 2000);
      }
    }
    this.selectedEntityNotes = this.modelData.myNotes.find(
      (eut: any) => eut.eID == eutChosen.eID
    );
    if (this.selectedEntityNotes) {
      this.quillEditorContent = this.selectedEntityNotes.notes;
    } else {
      this.quillEditorContent = '';
    }
    // console.log('selectedEntityDetails', this.selectedEntityDetails);
    if (!this.selectedEntityDetails) {
      this.addEUTDetails(eutChosen);
      this.selectedEntity = this.modelData.EUTdetails.find(
        (eut: any) => eut.eID == eutChosen.eID
      );
    } else {
    }
    // this.entityBC = this.selectedEntityDetails.bc;
    // this.entityAC = this.selectedEntityDetails.ac;
    // this.entityOC = this.selectedEntityDetails.outcomes;
    // this.entityPI = this.selectedEntityDetails.pIssues;
    if (eutChosen.eType == 'TF') {
      this.selectedTest = this.getDefaultTestTypeByEUTtype(eutChosen.eType);
      this.selectedTestName = 'Feature Behaviour';
    } else if (eutChosen.eType == 'UR') {
      this.selectedTest = this.getDefaultTestTypeByEUTtype(eutChosen.eType);
      this.selectedTestName = 'Requirement Behaviour';
    } else if (eutChosen.eType == 'BF') {
      this.selectedTest = this.getDefaultTestTypeByEUTtype(eutChosen.eType);
      this.selectedTestName = 'Flow Behaviour';
    }
  }
  updateEntityDetails() {
    // alert("new");
    for (var i = 0; i < this.modelData.EUTdetails.length; i++) {
      if (this.modelData.EUTdetails[i].eID == this.selectedEntity.eID) {
        this.modelData.EUTdetails[i]['bc'] = this.selectedEntityDetails.bc;
        this.modelData.EUTdetails[i]['ac'] = this.selectedEntityDetails.ac;
        this.modelData.EUTdetails[i]['outcomes'] = this.selectedEntityDetails.outcomes;
        this.modelData.EUTdetails[i]['pIssues'] = this.selectedEntityDetails.pIssues;
        this.syncModelDataObject = {
          "type": "SPECS",
          "operation": "UPDATE",
          "data": this.modelData.EUTdetails[i]
        }
        this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
      }
    }

  }
  addEUTDetails(eutChosen: any) {
    this.modelData.EUTdetails.push({
      eID: eutChosen.eID,
      bc: '',
      ac: '',
      outcomes: '',
      bDescription: '',
      pIssues: '',
      notes: this.config.entityDefaultNotes
    });
    
  }

  loadScenarioDetails(scenarioChoosen: any) {
    this.actionBtnsEnabled = true;
    this.plusBtnEnabled = true;
    this.selectedTestName = '';
    this.checklistName = scenarioChoosen.checklist;
    this.selectedChecklistAttr = scenarioChoosen.tID;
    if (scenarioChoosen.tID == 'Fe') {
      this.selectedTest = {
        name: 'Feature Behaviour',
        symbol: 'Fe',
        eType: 'TF',
        level: 'L4',
      };
      this.selectedTestName = 'Feature Behaviour';
    } else if (scenarioChoosen.tID == 'Rb') {
      this.selectedTest = {
        name: 'Requirement Behaviour',
        symbol: 'Rb',
        eType: 'UR',
        level: 'L5',
      };
      this.selectedTestName = 'Requirement Behaviour';
    } else if (scenarioChoosen.tID == 'Fl') {
      this.selectedTest = {
        name: 'Flow Behaviour',
        symbol: 'Fb',
        eType: 'BF',
        level: 'L5',
      };
      this.selectedTestName = 'Flow Behaviour';
    } else {
      this.matchedAttribute = this.model.attributes.find(
        (att: any) => att.symbol == scenarioChoosen.tID
      );
      if (this.matchedAttribute) {
        this.selectTest(this.matchedAttribute);
      }
    }
    this.attrDisabled = true;
  }
  getDefaultTestTypeByEUTtype(type: any) {
    var testType = this.testTypes.find(
      (test: any) => test.eType == type
    );
    return testType;
  }

  add(newScenario: any, id: any) {
    if (id > -1) {
      var scen = this.model.scenarios[id].description;
      if (scen) {
        // this.bcList = this.appService.stringToJson(scen, this.options);
        // if (this.bcList[0].name != "") {
        //   this.generateTestScenarios(id);
        // } else {
        //   this.model.add(
        //     this.checklistName,
        //     newScenario,
        //     this.selectedEntity.eID,
        //     this.selectedTest,
        //     id,
        //     this.designTest
        //   );
        // }
      }
    } else {
      this.model.add(
        this.checklistName,
        newScenario,
        this.selectedEntity.eID,
        this.selectedTest,
        id,
        this.designTest
      );
    }
    // $('#designerTextarea').focus(function () {
    //   $(this).setCursorPosition(1);
    // });
    // $("#designerTextarea").focus();
  }

  generateTestScenarios(id: any) {
    // controller.scenariosText = "";
    if (this.bcList.length > 0) {
      this.generatePostiveScenarios(id);
      this.generateNegativeScenarios(id);
    }
  }

  generatePostiveScenarios(id: any) {
    var resultPostiveScenario = [];
    var maxLengthOfTestConditons = 0;
    this.bcList.forEach((bc: any) => {
      maxLengthOfTestConditons = Math.max(
        maxLengthOfTestConditons
        // bc.value["positive"].length
      );
    });
    // for (var j = 0; j < maxLengthOfTestConditons; j++) {
    //   var testScenario = [];
    //   controller.bcList.forEach(function (bc) {
    //     if (bc.value["positive"] && bc.value["positive"].length > 0) {
    //       testScenario.push(
    //         bc.value["positive"][Math.min(j, bc.value["positive"].length - 1)]
    //       );
    //     }
    //   });
    //   resultPostiveScenario.push(testScenario);
    //   controller.scenariosText +=
    //     resultPostiveScenario.indexOf(testScenario) +
    //     1 +
    //     "." +
    //     testScenario +
    //     "\n";
    // }
    // if (controller.scenariosText) {
    //   this.model.add(
    //     this.checklistName,
    //     controller.scenariosText,
    //     this.selectedEntity.eID,
    //     this.selectedTest,
    //     id,
    //     this.designTest,
    //     "+"
    //   );
    // }
  }

  generateNegativeScenarios(id: any) {
    // var controller = this;
    // controller.scenariosText = "";
    // var resultNegativeScenario = [];
    // controller.bcList.forEach(function (bc, i) {
    //   bc.value["negative"].forEach(function (negativeTestCondition) {
    //     var testScenario = [];
    //     testScenario.push(negativeTestCondition);
    //     controller.bcList.forEach(function (positiveRandomTestCondition, k) {
    //       if (
    //         positiveRandomTestCondition.value["positive"] &&
    //         positiveRandomTestCondition.value["positive"].length > 0
    //       ) {
    //         if (i == k) return;
    //         else {
    //           testScenario.push(
    //             positiveRandomTestCondition.value["positive"][
    //             Math.floor(
    //               Math.random() *
    //               positiveRandomTestCondition.value["positive"].length
    //             )
    //             ]
    //           );
    //         }
    //       }
    //     });
    //     resultNegativeScenario.push(testScenario);
    //     controller.scenariosText +=
    //       resultNegativeScenario.indexOf(testScenario) +
    //       1 +
    //       "." +
    //       testScenario +
    //       "\n";
    //   });
    // });
    // if (controller.scenariosText) {
    //   this.model.add(
    //     this.checklistName,
    //     controller.scenariosText,
    //     this.selectedEntity.eID,
    //     this.selectedTest,
    //     id + 1,
    //     this.designTest,
    //     "-"
    //   );
    // }
  }

  // delete(id: any) {
  //   this.model.delete(id);
  // }
  //Function to clear the empty list
  onFocusOut(model: any, id: any) {
    if (!model) {
      this.delete(id);
    }
  }
  // selectTest(test: any) {
  //   this.newscenarioattr = test.name;
  //   this.newscenariosymbol = test.symbol;
  //   // this.selectedTest = test.symbol;
  //   // this.selectedTestName = test.name;
  // }
  editScenarioData(scenario: any) {
    // console.log("scenario",scenario);
    this.editScenario = scenario;
    this.editscenariodesc = scenario.description;
    this.newscenariopersona = scenario.persona;
    let matchedItem = this.config.listOfAttributesUpdated.find(
      (att: any) => att.symbol == scenario.tID
    );
    if (!matchedItem) {
      matchedItem = this.testTypes.find(
        (att: any) => att.symbol == scenario.tID
      );
    }
    if (matchedItem) {
      // console.log(matchedItem);
      this.newscenariosymbol = matchedItem.symbol;
      this.newscenarioattr = matchedItem.name;
      this.newscenariolevel = matchedItem.level;
      this.selectedTest = matchedItem;
    }
    this.newscenariopriority = scenario.priority;
    this.newscenariocr = scenario.cr;
    // this.newscenariopersona = scenario.persona;
  }

  CreateScenario() {
    // console.log(this.newscenarioattr);
    // console.log(this.newscenariosymbol);
    // console.log(this.newscenariodesc);
    // console.log(this.newscenariocr);
    // console.log(this.newscenariopriority);
    // console.log(this.modelData.scenarios);
    if (!this.selectedEntity.eID) {
      this.scenarioEmpty = "Please choose entity.";
      $('#emptyScenAddErrorPopup').modal('show');
      return;
    }
    this.newscenariodesc = this.editscenariodesc.trim();

    if (this.editScenario) {
      for (var i = 0; i < this.modelData.scenarios.length; i++) {
        if (this.modelData.scenarios[i].description.toLowerCase() == this.newscenariodesc.toLowerCase() && this.modelData.scenarios[i].tID == this.selectedTest.symbol && this.selectedEntity.eID == this.modelData.scenarios[i].eID) {
          if (this.modelData.scenarios[i].scenID != this.editScenario.scenID) {
            // this.errorMessage = this.AppService.getResourceText("V033");
            this.duplicateScenario = "'" + this.newscenariodesc + "'";
            $("#duplicateScenarioErrorPopupModelDesigner").modal("show");
            $('#designerScenTextarea').val(this.newscenariodesc);
            return;
          }
        }
      }
    } else {
      for (var j = 0; j < this.modelData.scenarios.length; j++) {
        if (this.modelData.scenarios[j].description.toLowerCase() == this.newscenariodesc.toLowerCase() && this.modelData.scenarios[j].tID == this.selectedTest.symbol && this.selectedEntity.eID == this.modelData.scenarios[j].eID) {
          this.errorMessage = "Scenario already exists";
          this.duplicateScenario = "'" + this.newscenariodesc + "'";
          $("#duplicateScenarioErrorPopupModelDesigner").modal("show");
          $('#designerScenTextarea').val(this.newscenariodesc);
          return;
        }
      }
    }
    if (this.editScenario) {
      // console.log('edit', this.newscenariodesc);
      if (this.newscenariodesc != '') {
        this.updateScenario(
          this.editScenario.scenID,
          this.selectedTest,
          this.newscenariocr,
          this.newscenariopriority,
          this.newscenariodesc
        );
        this.scenarioAddReset();
      } else {
        this.scenarioEmpty = "Scenario can't be empty.";
        $('#emptyScenAddErrorPopup').modal('show');
        return;
      }
    } else {
      var scenarioDesc = this.newscenariodesc.trim();
      // console.log("this.selectedEntity.eID", this.selectedEntity.eID);
      if (this.selectedEntity.eID == "" || this.selectedEntity.eID == undefined) {
        this.newscenariodesc = '';
        this.scenarioEmpty = "Scenario can't be empty.";
        $('#emptyScenAddErrorPopup').modal('show');
        $('#designerScenTextarea').val('');
        return;
      }
      if (scenarioDesc != '') {
        this.addScenario(
          '',
          scenarioDesc,
          this.selectedEntity.eID,
          this.selectedTest,
          '-1',
          'E',
          this.newscenariocr,
          this.newscenariopriority,
        );
        this.scenarioAddReset();
        $('#designerScenTable tr').removeClass('active');
      } else {
        this.newscenariodesc = '';
        this.scenarioEmpty = "Scenario can't be empty.";
        $('#emptyScenAddErrorPopup').modal('show');
        $('#designerScenTextarea').val('');
      }
    }
  }
  deleteScenarioModal(editscenariodesc: any) {
    if (editscenariodesc != '') {
      this.message = 'Would you like to delete?';
      $('#deleteScenarioConfirmPopupModel').modal('show');
    } else {
      this.newscenariodesc = '';
      this.scenarioEmpty = "Scenario can't be empty.";
      $('#emptyScenAddErrorPopup').modal('show');
    }

  }

  addScenario(
    checklistName: any,
    newScenario: any,
    eID: any,
    attribute: any,
    id: any,
    sType: any,
    cr: any,
    priority: any) {
    var scenario = {
      EorT: sType,
      scenID: this.uniqueSCID(),
      description: newScenario,
      eID: eID,
      tID: attribute.symbol,
      attribute: attribute,
      priority: priority || '1',
      cr: cr || '+',
    };

    // for (var i = 0; i < this.modelData.listOfEUTs.length; i++) {
    //   if (this.modelData.listOfEUTs[i].eID == eID) {
    //     this.modelData.listOfEUTs[i].scenarioCount++;
    //   }
    // }
    var newID = id + 1;
    // console.log("scenario", scenario);
    this.modelData.scenarios.unshift(scenario);
    this.syncModelDataObject = {
      "type": "SCENARIO",
      "operation": "CREATE",
      "data": scenario
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
    // this.scenarios.splice(newID, 0, scenario);
  }

  updateScenario(
    scenID: any,
    attr: any,
    cr: any,
    pri: any,
    desc: any
  ) {
    for (var i = 0; i < this.modelData.scenarios.length; i++) {
      if (this.modelData.scenarios[i].scenID == scenID) {
        this.modelData.scenarios[i].tID = attr.symbol;
        this.modelData.scenarios[i].attribute = attr;
        this.modelData.scenarios[i].cr = cr;
        this.modelData.scenarios[i].priority = pri;
        this.modelData.scenarios[i].description = desc;
        this.syncModelDataObject = {
          "type": "SCENARIO",
          "operation": "UPDATE",
          "data": this.modelData.scenarios[i]
        }
        this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
      }
    }
  }

  //generation of unique id for an scenario
  uniqueSCID() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return (
      'SC' +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      s4() +
      s4()
    );
  }
  deleteScenarioByEdit() {
    if (this.editScenario) {
      this.delete(this.editScenario.scenID);
    }
  }
  delete(scenID: any) {
    // console.log("sc",scenID);
    // if (id >= 0) {
    // console.log("scen", this.scenarios[id]);
    for (var i = 0; i < this.modelData.scenarios.length; i++) {
      if (scenID == this.modelData.scenarios[i].scenID) {
        // console.log("sc1",this.scenarios[i]);
        this.selectedDeleteScenEid = this.modelData.scenarios[i].eID;
        this.modelData.scenarios.splice(i, 1);
        this.syncModelDataObject = {
          "type": "SCENARIO",
          "operation": "DELETE",
          "data": this.editScenario
        }
        this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
        this.scenarioAddReset();
      }
    }
    // console.log("scccc",this.scenarios);
    this.deleteScenarioByID(scenID);
    for (var j = 0; j < this.modelData.listOfEUTs.length; j++) {
      if (this.modelData.listOfEUTs[j].eID == this.selectedDeleteScenEid) {
        this.modelData.listOfEUTs[j].scenarioCount--;
      }
    }
    //   return this.scenarios.splice(id, 1);
    // }
  }
  deleteScenarioByID(scenID: any) {
    // console.log("scen", scenario.scenID);
    if (scenID) {
      for (var i = 0; i < this.modelData.runInfo.length; i++) {
        if (scenID == this.modelData.runInfo[i].scenID) {
          this.modelData.runInfo.splice(i, 1);
          i--;
        }
      }
      for (var j = 0; j < this.modelData.suites.length; j++) {
        for (var k = 0; k < this.modelData.suites[j].scenarios.length; k++) {
          if (scenID == this.modelData.suites[j].scenarios[k]) {
            this.modelData.suites[j].scenarios.splice(k, 1);
            break;
          }
        }
      }
    }
  }
  scenarioAddReset() {
    this.newscenarioattr = 'Feature Behaviour';
    this.newscenariosymbol = 'Fe';
    this.newscenariocr = '+';
    this.newscenariopriority = '1';
    this.newscenariodesc = '';
    this.editscenariodesc = '';
    this.newscenariopersona = [];
    this.editScenario = '';
    $('#designerScenTextarea').val('');
  }

  testLinkExist(test: any) {
    if (this.designTest == 'T' && this.selectedTest != '') {
      // var scenarios = this.model.scenarios.filter(
      //   scenario =>
      //     scenario.EorT == controller.designTest &&
      //     scenario.eID == undefined &&
      //     scenario.tID == controller.selectedTest
      // );
      // if (scenarios.length > 0) {
      //   let TTLinked = '';
      //   if (controller.selectedTest == "Fe") {
      //     TTLinked = "Feature Behaviour"
      //   } else if (controller.selectedTest == "Rb") {
      //     TTLinked = "Requirement Behaviour"
      //   } else if (controller.selectedTest == "Fl") {
      //     TTLinked = "Flow Behaviour"
      //   } else {
      //     let matchedItem = this.model.attributes.find(att => att.symbol == controller.selectedTest);
      //     if (matchedItem) {
      //       TTLinked = matchedItem.name;
      //     }
      //   }
      //   let errorMessage = this.AppService.getResourceText("V021a") + TTLinked
      //     + this.AppService.getResourceText("V021b") + '[' + scenarios[0].checklist
      //     + ']' + this.AppService.getResourceText("V021c");
      //   this.triggerToastPopup(errorMessage);
      //   this.selectedTest = '';
      //   this.selectedTestName = '';
      // }
    }
  }

  //function to get scenario count by eutID
  getScenarioCountByeutID(eut: any) {
    var count = 0;
    for (var i = 0; i < this.modelData.scenarios.length; i++) {
      if (this.modelData.scenarios[i].eID == eut.eID) {
        count++;
      }
    }
    return count;
  }

  triggerToastPopup(message: any) {
    this.toastMsgPopup = message;
    // $('#designerMsgPopup').modal('toggle');
  }
  // editScenario(scenario){
  //   console.log("scen",scenario);
  //   let matchedItem = this.testTypes.find(att => att.symbol == scenario.tID);
  //   if (matchedItem) {
  //     this.selectedTest = matchedItem.symbol;
  //     this.selectedTestName = matchedItem.name;
  //   }
  // }
  selectModule(test: any) {
    this.selectedModule = test;
    // console.log(this.selectedModule);
    this.selectedEntity = {};
    this.selectedEntityDetails = {};
    this.entityName = '';
    this.selectedTest = '';
    this.selectedTestName = '';
    this.selectedEntityeID = '';
    this.index = this.eutTypes.findIndex((type: any) => type == test);
    if (test == 'TT') {
      this.designTest = 'T';
    } else {
      this.designTest = 'E';
    }
    this.checklistName = '';
    this.entityBC = '';
    this.entityOC = '';
    this.entityPI = '';
    this.entityAC = '';
    this.quillEditorContent = '';
    this.actionBtnsEnabled = false;
    this.plusBtnEnabled = true;
    this.editCheckList = false;
    this.oldCheckListName = '';
    this.showText = false;
    this.widgetDisabled = true;
  }

  selectEditorAttr(attr: any) {
    this.selectedEditorAttr = attr;
    this.selectedEditorAttribute = attr;
  }

  mapScenarioToPerson(persona: any, isChecked: any) {
    // console.log(isChecked);
    // console.log(persona);
    if (isChecked) {
      var index = this.newscenariopersona.findIndex(
        (person: any) => person == persona
      );
      if (index == -1) {
        this.newscenariopersona.push(persona);
      }
    } else {
      var index = this.newscenariopersona.findIndex(
        (person: any) => person == persona
      );
      if (index > -1) {
        this.newscenariopersona.splice(index, 1);
      }
    }
    // console.log(this.newscenariopersona);
  }

  scenarioExist() {
    if (this.selectedEntity) {
      if (this.designTest == 'E' && this.selectedEntity.eID != undefined) {
        var scenarios = this.model.scenarios
          .filter
          // scenario =>
          //   scenario.EorT == this.designTest &&
          //   scenario.eID == this.selectedEntity.eID &&
          //   scenario.tID == this.selectedTest
          ();
        if (scenarios.length <= 0) {
          return true;
        }
      } else if (this.designTest == 'T' && this.selectedTest != '') {
        var scenarios = this.model.scenarios
          .filter
          // scenario =>
          //   scenario.EorT == this.designTest &&
          //   scenario.eID == undefined &&
          //   scenario.tID == this.selectedTest
          ();
        if (scenarios.length <= 0) {
          return true;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
    return false;
  }
  checkAttributeDesc(Attribute: any, checkFor: any) {
    var concatAttr = Attribute.name + ' (' + Attribute.symbol + ')';
    this.matchedAttribute = this.listOfAttributes.find(
      (att: any) => att.aType == concatAttr
    );
    if (this.matchedAttribute) {
      if (this.matchedAttribute.aDetail == '') {
        if (checkFor == 'text') {
          return 'attributeNoFont';
        } else {
          return true;
        }
      } else {
        if (checkFor == 'text') {
          return 'attributeFont';
        } else {
          return false;
        }
      }
    }
    return false;
  }
  showScenario(scenario: any) {
    if (this.selectedEntity) {
      if (scenario.EorT == 'E') {
        if (
          scenario.EorT == this.designTest &&
          scenario.eID == this.selectedEntity.eID
          //  &&
          // scenario.tID == controller.selectedTest
        ) {
          return true;
        }
      } else if (scenario.EorT == 'T') {
        if (
          scenario.EorT == this.designTest &&
          scenario.eID == undefined
          // &&
          // scenario.tID == controller.selectedTest
        ) {
          return true;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
    return false;
  }

  checkAttributeMap(attribute: any) {
    // console.log("attr",attribute);
    // console.log("this.selectedEntity",this.selectedEntity);
    // console.log("this.scopeMap",this.scopeMap);
    if (this.selectedEntity) {
      // this.mappedAttribute = this.scopeMap.find((scope: any) => scope.aType == attribute.symbol && scope.eID == this.selectedEntity.eID);
      // if (this.mappedAttribute) {
      //   return true;
      // } else {
      //   return false;
      // }
    }
    return false;
  }
  entityExists(eType: any) {
    var entityPresent = this.model.entityModel.entityExists(eType);
    return entityPresent;
  }

  getEntityType(eType: any) {
    var entityName = this.model.entityModel.getEntityType(eType);
    return entityName;
  }
  terminateVideo() {
    var iframes = document.querySelectorAll('iframe');
    Array.prototype.forEach.call(iframes, (iframe) => {
      iframe.contentWindow.postMessage(
        JSON.stringify({
          event: 'command',
          func: 'stopVideo',
        }),
        '*'
      );
    });
  }

  generateReport(auto: any) {
    let mapperArray = ['Designer'];
    window.localStorage.setItem('exportedData', JSON.stringify(mapperArray));
    window.localStorage.setItem(
      'scenarioEntity',
      JSON.stringify(['TF', 'UR', 'BF', 'XX'])
    );
    if (auto == 'true') {
      window.open('/exportReport', '_blank');
      window.localStorage.setItem('autoDownload', 'true');
    }
  }
  // function is used for level filter
  addToLevelFilter(id: any, isChecked: any) {
    if (isChecked) {
      this.levelSelected.push(id);
    } else {
      var isPresent = this.levelSelected.findIndex((a: any) => a == id);
      if (isPresent > -1) {
        this.levelSelected.splice(isPresent, 1);
      }
    }
    this.scenarioAddReset();
    // console.log('Level', this.levelSelected);
  }
  // function is used for attr filter
  addToAttributeFilter(id: any, isChecked: any) {
    // console.log(id,isChecked);
    if (isChecked) {
      this.attributeSelected.push(id);
    } else {
      var isPresent = this.attributeSelected.findIndex((a: any) => a == id);
      if (isPresent > -1) {
        this.attributeSelected.splice(isPresent, 1);
      }
    }
    this.scenarioAddReset();
    // console.log('Attr', this.attributeSelected);
  }

  isCheckedAtt(attribute: any) {
    if (this.attributeSelected.length > 0) {
      var a = this.attributeSelected.findIndex((a: any) => a == attribute);
      return a > -1 ? true : false;
    } else {
      return false;
    }
  }
  // function is used for attr filter
  isPresentInACollection(attribute: any) {
    var isPresent = this.attributeSelected.findIndex(
      (a: any) => a == attribute
    );
    if (isPresent > -1) {
      return true;
    } else return false;
  }

  // function is used for persona filter
  addToPersonaFilter(id: any, isChecked: any) {
    if (isChecked) {
      this.personaSelected.push(id);
    } else {
      var isPresent = this.personaSelected.findIndex(
        (persona: any) => persona == id
      );
      if (isPresent > -1) {
        this.personaSelected.splice(isPresent, 1);
      }
    }
    this.scenarioAddReset();
    // console.log('Per', this.personaSelected);
  }

  // function is used for persona filter
  isPresentInPCollection(persona: any) {
    var isPresent = this.personaSelected.some((r: any) => persona.includes(r));
    if (isPresent) {
      return true;
    } else return false;
  }

  // function is used for priority & cr filter
  addToCrFilter(cr: any, isChecked: any) {
    if (isChecked) {
      this.crSelected.push(cr);
    } else {
      var isPresent = this.crSelected.findIndex((value: any) => value == cr);
      if (isPresent > -1) {
        this.crSelected.splice(isPresent, 1);
      }
    }
    this.scenarioAddReset();
    // console.log('CR', this.crSelected);
  }

  // function is used for priority & cr filter
  isPresentInCrCollection(scen: any) {
    var prioStr = '';
    if (scen.cr == '+') {
      prioStr = '+' + scen.priority;
    } else {
      prioStr = '-' + scen.priority;
    }
    var isPresent = this.crSelected.findIndex((p: any) => p === prioStr);
    if (isPresent > -1) {
      return true;
    } else {
      return false;
    }
  }

  generateMindMap(){
    this.mainComponent.sendJson(this.selectedEntity);
  }
}
